/* eslint-disable camelcase */

import { Analytics } from '..';

export interface AccountData {
    first_name: string;
    last_name: string;
    phone: string;
    phone2: string;
    email: string;
    user_id: string;
    userId: string;
    picture: string;
}

export default function account(self: Analytics) {
    return {
        userId(userId: number | string) {
            self.dataLayer({
                event: 'userid',
                userId,
            });
            return self;
        },
        contactInfo(data: AccountData) {
            self.dataLayer({
                event: 'account',
                action: 'contact_info',
                data,
            });
            self.fbq('track', 'Contact');
            return self;
        },
        subscribe(data: AccountData) {
            self.dataLayer({
                event: 'account',
                action: 'subscribed',
                data,
            });
            self.fbq('track', 'Lead');
            return self;
        },
    };
}
